import { call, put, StrictEffect, takeEvery } from "redux-saga/effects";

import { DataType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";

import { performDataAction } from "@/services/api";

import {
  DocumentStatusActions,
  getDocumentStatus,
  setDocumentStatus,
  setDocumentStatusError
} from "./documentUploadStatus";

export function* handleDocumentStatus(
  action: DocumentStatusActions
): Generator<StrictEffect, void, any> {
  const { clientId } = action.payload;
  try {
    const response = yield call(
      performDataAction,
      DataType.DocumentsStatus,
      "list",
      { companyId: clientId }
    );
    yield put(setDocumentStatus({ status: response.status }));
  } catch (error) {
    yield put(setDocumentStatusError(extractError(error)));
  }
}

export default function* documentUploadStatusSaga() {
  yield takeEvery(getDocumentStatus.type, handleDocumentStatus);
}
